/* CLEVO: keeps --sticky-h in sync with the pinned bar + header, and rotates announcement messages */
(function () {
  'use strict';
  function initSticky() {
    var el = document.querySelector('[data-sticky-top]');
    if (!el) return;
    var set = function () { document.documentElement.style.setProperty('--sticky-h', el.offsetHeight + 'px'); };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(el); else window.addEventListener('resize', set);
  }
  function initAnnouncement(root) {
    var bar = (root || document).querySelector('[data-announcement]');
    if (!bar || bar._clevoTimer) return;
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('.announcement-msg'));
    if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, paused = false, secs = Number(bar.getAttribute('data-interval')) || 5;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    bar._clevoTimer = setInterval(function () {
      if (paused || document.hidden) return;
      msgs[i].classList.remove('is-active'); msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden');
    }, secs * 1000);
  }
  function init() {
    initSticky();
    initAnnouncement(document);
    document.addEventListener('shopify:section:load', function (e) { initAnnouncement(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
